import { getSocialMediaPlatform, getPostMediaType_short } from './getSurveysWithExtractedFields';
import { industryDataCodes, dataCodeFields } from '../config/dataCodes';
import { USA_States, Global_Region } from '../config/dataCodes';
import { COUNTRY_LABELS } from '../config/batchConfig';

export const normalize_slider_value = value => {
  const normalizedValue = convertRange(value, [-100, 100], [0, 1]);
  return normalizedValue;
};

export const convert_normalized_slider_value = value => {
  const convertedNormalizedValue = Math.round(convertRange(value, [0, 1], [-100, 100]));
  return convertedNormalizedValue;
};

export const normalize_slider_positive_value = value => {
  const normalizedValue = convertRange(value, [0, 100], [0, 1]);
  return normalizedValue;
};

export const convert_normalized_slider_positive_value = value => {
  const convertedNormalizedValue = Math.round(convertRange(value, [0, 1], [0, 100]));
  return convertedNormalizedValue;
};

export const reverse_normalize_slider_positive_value = value => {
  const normalizedValue = convertRange(value, [0, 100], [1, 0]);
  return normalizedValue;
};

export const convert_reverse_normalized_slider_positive_value = value => {
  const originalValue = convertRange(value, [1, 0], [0, 100]);
  return originalValue;
};

export const isPositiveSliderValue = (type, id) => {
  if (id.includes(`${type}InterExter`) || id.includes(`${type}Issues`)) {
    return true;
  }

  return false;
};

export const getAverage = arr => {
  let sum = arr.reduce((a, b) => a + b, 0);
  return sum / arr.length;
};

export const pushRangeOfNumbers = (arr, start, end) => {
  let updatedArr = [...arr];
  for (let i = start; i <= end; i++) {
    updatedArr.push(i);
  }
  return updatedArr;
};

export const convertRange = (value, r1, r2) => {
  return ((value - r1[0]) * (r2[1] - r2[0])) / (r1[1] - r1[0]) + r2[0];
};

export const makeURL = route => {
  const baseUrl = '';
  return `${baseUrl}${route}`;
};

export const rearrangeSurveyData = (arr, key, up, type, brandPersonas) => {
  const reMappedKey = getReMappedKey(type, key);

  let arrayToSort = type === 'social' ? mapSocialMediaDataSource(arr, brandPersonas) : arr;

  arrayToSort.sort(function(a, b) {
    const aVal = a[reMappedKey];
    const bVal = b[reMappedKey];

    if (getShouldLocalCompare(reMappedKey)) {
      if (aVal == undefined && bVal == undefined) return 0;
      if (aVal == undefined) return up ? -1 : 1;
      if (bVal == undefined) return up ? 1 : -1;

      return up ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
    } else if (getShouldTimestampCompare(reMappedKey)) {
      const aSec = aVal?._seconds ?? 0;
      const bSec = bVal?._seconds ?? 0;
      return up ? aSec - bSec : bSec - aSec;
    } else {
      const aNum = aVal ?? 0;
      const bNum = bVal ?? 0;
      return up ? aNum - bNum : bNum - aNum;
    }
  });

  return arrayToSort;
};

const mapSocialMediaDataSource = (socialMediaData, brandPersonas) => {
  return socialMediaData.map(item => {
    const { Name: personaName } = brandPersonas.find(({ id }) => id === item.Post_Brand_Persona);

    return {
      ...item,
      Post_Brand_Persona_Text: personaName ? personaName : '',
      Post_Social_Media_Text: getSocialMediaPlatform(item),
      Post_Media_Type_Text: getPostMediaType_short(item),
    };
  });
};

const getShouldLocalCompare = reMappedKey => {
  let shouldLocalCompare = false;

  if (
    reMappedKey === 'Name' ||
    reMappedKey === 'name' ||
    reMappedKey === 'industry' ||
    reMappedKey === 'Post_Title' ||
    reMappedKey === 'Post_Brand_Persona_Text' ||
    reMappedKey === 'Post_Media_Type_Text' ||
    reMappedKey === 'Post_Social_Media_Text' ||
    reMappedKey === 'brandName' ||
    reMappedKey === 'quarter' ||
    reMappedKey === 'suggestion'
  ) {
    shouldLocalCompare = true;
  }

  return shouldLocalCompare;
};

const getShouldTimestampCompare = reMappedKey => {
  return reMappedKey === 'lastEdited' || reMappedKey === 'dateCreated' || reMappedKey === 'Post_Date';
};

const getReMappedKey = (type, key) => {
  let reMappedKey = '';

  switch (type) {
    case 'competitive-brand':
      reMappedKey = recentCardFilterKeysReMapped_CompetitiveSetBrands(key);
      break;
    case 'brand-consumers':
      reMappedKey = recentCardFilterKeysReMapped_BrandConsumers(key);
      break;
    case 'social':
      reMappedKey = recentCardFilterKeysReMapped_SocialMedia(key);
      break;
    case 'clients':
      reMappedKey = recentCardFilterKeysReMapped_Clients(key);
      break;
    default:
      reMappedKey = recentCardFilterKeysReMapped(key);
  }

  return reMappedKey;
};

const recentCardFilterKeysReMapped_Clients = key => {
  switch (key) {
    case 'Client':
      return 'name';
    case 'Date Added':
      return 'createdAt';
    case 'Users':
      return 'userCount';
    case 'Brand Personas':
      return 'brandPersonaSurveyCount';
    case 'Buyer Personas':
      return 'buyerPersonaSurveyCount';
    case 'Campaigns':
      return 'socialPostSurveyCount';
    default:
      return 'undefined';
  }
};

const recentCardFilterKeysReMapped = key => {
  switch (key) {
    case 'Personas Name':
      return 'Name';
    case 'Last Edited':
      return 'lastEdited';
    case 'Date Created':
      return 'dateCreated';
    case 'Social V. Match':
      return 'socialValueMatch';
    case 'Product B. Match':
      return 'productBenefitsMatch';
    case 'Total Match':
      return 'totalMatch';
    case 'Filter':
      return 'filter';
    default:
      return 'undefined';
  }
};

export const timeSince = timestamp => {
  const seconds = Math.floor((new Date() - timestamp * 1000) / 1000);

  let interval = Math.floor(seconds / 31536000);
  if (interval >= 1) {
    return interval + ' year' + (interval === 1 ? '' : 's') + ' ago';
  }

  interval = Math.floor(seconds / 2592000);
  if (interval >= 1) {
    return interval + ' month' + (interval === 1 ? '' : 's') + ' ago';
  }

  interval = Math.floor(seconds / 86400);
  if (interval >= 1) {
    return interval + ' day' + (interval === 1 ? '' : 's') + ' ago';
  }

  interval = Math.floor(seconds / 3600);
  if (interval >= 1) {
    return interval + ' hour' + (interval === 1 ? '' : 's') + ' ago';
  }

  interval = Math.floor(seconds / 60);
  if (interval >= 1) {
    return interval + ' minute' + (interval === 1 ? '' : 's') + ' ago';
  }

  return Math.floor(seconds) + ' second' + (seconds === 1 ? '' : 's') + ' ago';
};

export const formatTimestampToDate = timestamp => {
  const date = new Date(timestamp * 1000);

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const monthIndex = date.getMonth();
  const monthName = months[monthIndex];
  const day = date.getDate();
  const year = date.getFullYear();

  return `${monthName} ${day}, ${year}`;
};

export const getSocialPostIdsForConversion = () => {
  return {
    normalize: [
      'Post_Ideology_1',
      'Post_InterExter_1',
      'Post_LocalGlobal_1',
      'Post_Product_1',
      'Post_Product_2',
      'Post_Product_3',
      'Post_Product_4',
      'Post_Product_5',
      'Post_Product_6',
      'Post_Product_7',
      'Post_Product_8',
      'Post_Product_9',
      'Post_Product_10',
      'Post_IssuesSupport_1',
      'Post_IssuesSupport_2',
      'Post_IssuesSupport_3',
      'Post_IssuesSupport_4',
      'Post_IssuesSupport_5',
      'Post_IssuesSupport_6',
      'Post_IssuesSupport_7',
      'Post_IssuesSupport_8',
      'Post_IssuesSupport_9',
      'Post_IssuesSupport_10',
      'Post_IssuesSupport_11',
      'Post_IssuesSupport_12',
      'Post_IssuesSupport_13',
      'Post_IssuesSupport_14',
      'Post_IssuesSupport_15',
      'Post_IssuesSupport_16',
      'Post_IssuesSupport_17',
      'Post_IssuesSupport_18',
    ],
    positive_normalize: ['Post_Inovation_1'],
  };
};

export const getBrandBuyerSurveyIdsForConversion = () => {
  return {
    normalize: [
      '_LocalGlobal_1',
      '_LocalGlobal_2',
      '_LocalGlobal_3',
      '_Ideology_1',
      '_Ideology_2',
      '_Ideology_3',
      '_Ideology_4',
      '_Product_1',
      '_Product_2',
      '_Product_3',
      '_Product_4',
      '_Product_5',
      '_Product_6',
      '_Product_7',
      '_Product_8',
      '_Product_9',
      '_Product_10',
      '_IssuesSupport_1',
      '_IssuesSupport_2',
      '_IssuesSupport_3',
      '_IssuesSupport_4',
      '_IssuesSupport_5',
      '_IssuesSupport_6',
      '_IssuesSupport_7',
      '_IssuesSupport_8',
      '_IssuesSupport_9',
      '_IssuesSupport_10',
      '_IssuesSupport_11',
      '_IssuesSupport_12',
      '_IssuesSupport_13',
      '_IssuesSupport_14',
      '_IssuesSupport_15',
      '_IssuesSupport_16',
      '_IssuesSupport_17',
      '_IssuesSupport_18',
    ],
    reverse_normalize: ['_InterExter_1', '_InterExter_2'],
    positive_normalize: [
      '_InterExter_3',
      '_InterExter_4',
      '_InterExter_5',
      '_InterExter_6',
      '_SocialInovation_1',
      '_SocialInovation_2',
      '_SocialInovation_3',
      '_Issues_1',
      '_Issues_2',
      '_Issues_3',
      '_Issues_4',
      '_Issues_5',
      '_Issues_6',
      '_Issues_7',
      '_Issues_8',
      '_Issues_9',
      '_Issues_10',
      '_Issues_11',
    ],
  };
};

/*
// OLD AI STRATEGY GENERATOR FORMATOR
export const formatResponse = response => {
  if (!response || typeof response !== 'string') {
    return null; // Return early if the response is not valid
  }

  const lines = response.split('\n');
  let paragraphs = [];
  let currentParagraph = [];
  let isList = false;

  lines.forEach((line, idx) => {
    if (line.startsWith('- ')) {
      if (!isList) {
        isList = true;
        if (currentParagraph.length > 0) {
          paragraphs.push(
            <p
              key={paragraphs.length}
              style={{
                marginTop: '24px',
              }}>
              {currentParagraph}
            </p>,
          );
          currentParagraph = [];
        }
      }
      currentParagraph.push(<li key={currentParagraph.length}>{line.substring(2)}</li>);
    } else {
      if (isList) {
        isList = false;
        paragraphs.push(
          <ul key={paragraphs.length} style={{ paddingLeft: '32px' }}>
            {currentParagraph}
          </ul>,
        );
        currentParagraph = [];
      }
      currentParagraph.push(<p key={currentParagraph.length}>{line}</p>);
    }
  });

  if (currentParagraph.length > 0) {
    paragraphs.push(
      <p key={paragraphs.length} style={{ paddingLeft: '32px' }}>
        {currentParagraph}
      </p>,
    );
  }

  return paragraphs;
};
*/

export const socialDeleteFieldsWithFalseDependancy = surveyData => {
  let surveyDataCopy = { ...surveyData };
  const { Post_Category } = surveyDataCopy;

  if (Post_Category == 2) return surveyDataCopy;

  if (Post_Category == 1) {
    // Delete properties for Post_Category "1"
    for (const key in surveyDataCopy) {
      if (
        key.startsWith('Post_Issues_') ||
        key.startsWith('Post_IssuesSupport_') ||
        key === 'Post_LocalGlobal_1' ||
        key === 'Post_InterExter_1' ||
        key === 'Post_Ideology_1' ||
        key === 'Post_Inovation_1'
      ) {
        delete surveyDataCopy[key];
      }
    }
  } else {
    // Delete properties for other Post_Category values
    for (const key in surveyDataCopy) {
      if (key.startsWith('Post_Product_')) {
        delete surveyDataCopy[key];
      }
    }
  }

  return surveyDataCopy;
};

const recentCardFilterKeysReMapped_CompetitiveSetBrands = key => {
  switch (key) {
    case 'Brand':
      return 'name';
    case 'Industry':
      return 'industry';
    case 'Reputation':
      return 'CReputation';
    case 'Relationship':
      return 'CRelationship';
    case 'Brand Choice':
      return 'CPurchaseChoice';
    case 'Loyalty':
      return 'CLoyalty';
    case 'IE Focus':
      return 'IE_Focus_Match';
    case 'Ideology':
      return 'Ideology_Match';
    case 'Issues':
      return 'Issues_Match';
    case 'SV Match':
      return 'Values_Match';
    case 'PB Match':
      return 'Product_Match';
    case 'Total Match':
      return 'Total_Match';
    default:
      return 'undefined';
  }
};

const recentCardFilterKeysReMapped_BrandConsumers = key => {
  switch (key) {
    case 'Brand':
      return 'brandName';
    case 'Quarter':
      return 'quarter';
    case 'Year':
      return 'year';
    default:
      return 'undefined';
  }
};

const recentCardFilterKeysReMapped_SocialMedia = key => {
  switch (key) {
    case 'Post Title':
      return 'Post_Title';
    case 'Last Edited':
      return 'lastEdited';
    case 'Scheduled Date':
      return 'Post_Date';
    case 'Persona':
      return 'Post_Brand_Persona_Text';
    case 'Content Type':
      return 'Post_Media_Type_Text';
    case 'Platform':
      return 'Post_Social_Media_Text';
    case 'Impact':
      return 'impact';
    case 'Suggestion':
      return 'suggestion';
    case 'Filter':
      return 'filter';
    default:
      return 'undefined';
  }
};

export const getTop5RecentlyEdited = items => {
  //If items do not exist, return
  if (!items) return items;

  // Sort the items based on the 'lastEdited' property in descending order
  const sortedItems = items.sort((a, b) => {
    return b.lastEdited._seconds - a.lastEdited._seconds;
  });

  // Return the top 5 items or all items if there are fewer than 5
  return sortedItems.slice(0, Math.min(sortedItems.length, 5));
};

export const uncheckGenGroupFilters = () => {
  const genZSwitch = document.getElementById('GenZ(10-25Years)');
  const genYSwitch = document.getElementById('GenY(26-41Years)');
  const genXSwitch = document.getElementById('GenX(42-57Years)');
  const boomersSwitch = document.getElementById('Boomers(58-76Years)');
  const silentSwitch = document.getElementById('Silent(77+Years)');

  genZSwitch.checked = false;
  genYSwitch.checked = false;
  genXSwitch.checked = false;
  boomersSwitch.checked = false;
  silentSwitch.checked = false;
};

export const uncheckAgeGroupFilters = () => {
  const youngSwitch = document.getElementById('Young18-34');
  const middleSwitch = document.getElementById('Middle35-49');
  const olderSwitch = document.getElementById('Older50+');

  youngSwitch.checked = false;
  middleSwitch.checked = false;
  olderSwitch.checked = false;
};

export const uncheckIncomeGroupFilters = () => {
  const lowSwitch =
    document.getElementById('Low(under$49,999)') ||
    document.getElementById('Low(under1.999€)') ||
    document.getElementById('Low(under£1.999)');
  const middleSwitch =
    document.getElementById('Middle($50,000-$99,999)') ||
    document.getElementById('Middle(2.000€-3.199€)') ||
    document.getElementById('Middle(£2.000-£3.199)');

  const highSwitch =
    document.getElementById('High($100,000+)') ||
    document.getElementById('High(3.200€ormore)') ||
    document.getElementById('High(£3.200ormore)');

  lowSwitch.checked = false;
  middleSwitch.checked = false;
  highSwitch.checked = false;
};

export const uncheckIncomeBracketFilters = () => {
  const firstSwitch =
    document.getElementById('LESSTHAN$15,000') ||
    document.getElementById('LESSTHAN500€') ||
    document.getElementById('LESSTHAN£500');
  const secondSwitch =
    document.getElementById('$10,000-$24,999') ||
    document.getElementById('500€-899€') ||
    document.getElementById('£500-£899');
  const thirdSwitch =
    document.getElementById('$25,000-$34,999') ||
    document.getElementById('900€-1.499€') ||
    document.getElementById('£900-£1.499');
  const fourthSwitch =
    document.getElementById('$35,000-$49,999') ||
    document.getElementById('1.500€-1.999€') ||
    document.getElementById('£1.500-£1.999');
  const fifthSwitch =
    document.getElementById('$50,000-$74,999') ||
    document.getElementById('2.000€-2.599€') ||
    document.getElementById('£2.000-£2.599');
  const sixthSwitch =
    document.getElementById('$75,000-$99,999') ||
    document.getElementById('2.600€-3.199€') ||
    document.getElementById('£2.600-£3.199');
  const seventhSwitch =
    document.getElementById('$100,000-$149,999') ||
    document.getElementById('3.200€-4.499€') ||
    document.getElementById('£3.200-£4.499');
  const eightSwitch =
    document.getElementById('$150,000-$199,999') ||
    document.getElementById('4.500€-5.999€') ||
    document.getElementById('£4.500-£5.999');
  const ninthSwitch =
    document.getElementById('$200,000+') ||
    document.getElementById('6.000€ormore') ||
    document.getElementById('£6.000ormore');

  firstSwitch.checked = false;
  secondSwitch.checked = false;
  thirdSwitch.checked = false;
  fourthSwitch.checked = false;
  fifthSwitch.checked = false;
  sixthSwitch.checked = false;
  seventhSwitch.checked = false;
  eightSwitch.checked = false;
  ninthSwitch.checked = false;
};

export const getShouldCalculateAgeRange = () => {
  const ageSlider = document.querySelector('#ageRange input');

  if (ageSlider.value !== '0,0') {
    return true;
  }

  return false;
};

export const getUserInitials = username => {
  if (!username) return '';
  const isEmail = username.indexOf('@');
  let displayName = username;

  if (isEmail !== -1) {
    displayName = username.substring(0, username.indexOf('@'));
  }
  let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

  let initials = [...displayName.matchAll(rgx)] || [];

  initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();

  return initials;
};

export const getIndustryName = industryCode => {
  if (typeof industryCode === 'string')
    return industryDataCodes.find(industry => industry.name.toLowerCase() === industryCode.toLowerCase());
  else return industryDataCodes.find(industry => industry.id === industryCode);
};

export const getIssuesFromBrandPersona = (persona, type) => {
  const personaType = type === 'brand' ? 'Brand' : 'Buyer';
  const questionIDs = [
    `${personaType}_Issues_1`,
    `${personaType}_Issues_2`,
    `${personaType}_Issues_3`,
    `${personaType}_Issues_4`,
    `${personaType}_Issues_5`,
    `${personaType}_Issues_6`,
    `${personaType}_Issues_7`,
    `${personaType}_Issues_8`,
    `${personaType}_Issues_9`,
    `${personaType}_Issues_10`,
    `${personaType}_Issues_11`,
  ];
  const questionText = [
    'State of the economy',
    'Free Healthcare',
    'Violent crime',
    'World peace',
    'Gun laws',
    'Race and ethnic inequality',
    'Gender inequality',
    'Immigration',
    'Economic inequality',
    'Climate change',
    'Corporate corruption',
  ];

  const extractedValues = questionText.map(
    (e, index) => `${e}(${convert_normalized_slider_positive_value(persona[questionIDs[index]])})`,
  );
  return extractedValues;
};

export const getStateByCode = code => {
  let value = USA_States.find(state => state.value == code);
  return value?.text;
};

export const getRegionByStateName = stateName => {
  const stateRegionMap = {
    Alabama: 'West',
    Alaska: 'South',
    Arizona: 'South',
    Arkansas: 'West',
    California: 'West',
    Colorado: 'West',
    Connecticut: 'Northeast',
    Delaware: 'South',
    'District of Columbia': 'South',
    Florida: 'South',
    Georgia: 'South',
    Hawaii: 'West',
    Idaho: 'West',
    Illinois: 'Midwest',
    Indiana: 'Midwest',
    Iowa: 'Midwest',
    Kansas: 'Midwest',
    Kentucky: 'South',
    Louisiana: 'South',
    Maine: 'Northeast',
    Maryland: 'South',
    Massachusetts: 'Northeast',
    Michigan: 'Midwest',
    Minnesota: 'Midwest',
    Mississippi: 'South',
    Missouri: 'Midwest',
    Montana: 'West',
    Nebraska: 'Midwest',
    Nevada: 'West',
    'New Hampshire': 'Northeast',
    'New Jersey': 'Northeast',
    'New Mexico': 'West',
    'New York': 'Northeast',
    'North Carolina': 'South',
    'North Dakota': 'Midwest',
    Ohio: 'Midwest',
    Oklahoma: 'South',
    Oregon: 'West',
    Pennsylvania: 'Northeast',
    'Puerto Rico': 'Overseas',
    'Rhode Island': 'Northeast',
    'South Carolina': 'South',
    'South Dakota': 'Midwest',
    Tennessee: 'South',
    Texas: 'South',
    Utah: 'West',
    Vermont: 'Northeast',
    Virginia: 'South',
    Washington: 'West',
    'West Virginia': 'South',
    Wisconsin: 'Midwest',
    Wyoming: 'West',
    'I do not reside in the United States': null,
  };

  return stateRegionMap[stateName] || null;
};

export const getOriginByCode = code => {
  const originMap = [
    {
      text: 'Native-Born',
      value: 1,
    },
    {
      text: 'Foreign-Born',
      value: 7,
    },
  ];

  const foundOrigin = originMap.find(e => e.value == code);
  return foundOrigin?.text;
};

export const getIncomeByCode_USA = code => {
  const incomeMap = [
    {
      text: 'Less than $10,000',
      value: 1,
    },
    {
      text: '$10,000 - $24,999',
      value: 2,
    },
    {
      text: '$25,000 - $34,999',
      value: 3,
    },
    {
      text: '$35,000 - $49,999',
      value: 4,
    },
    {
      text: '$50,000 - $74,999',
      value: 5,
    },
    {
      text: '$75,000 - $99,999',
      value: 6,
    },
    {
      text: '$100,000 - $149,999',
      value: 7,
    },
    {
      text: '$150,000 - $199,999',
      value: 8,
    },
    {
      text: '$200,000 +',
      value: 9,
    },
  ];

  const foundIncome = incomeMap.find(e => e.value == code);
  return foundIncome?.text;
};

export const getIncomeByCode_EU = code => {
  const incomeMap = [
    {
      text: 'Less than 500 €',
      value: 1,
    },
    {
      text: '500 € - 899 €',
      value: 2,
    },
    {
      text: '900 € - 1.499 €',
      value: 3,
    },
    {
      text: '1.500 € - 1.999 €',
      value: 4,
    },
    {
      text: '2.000 € - 2.599 €',
      value: 5,
    },
    {
      text: '2.600 € - 3.199 €',
      value: 6,
    },
    {
      text: '3.200 € - 4.499 €',
      value: 7,
    },
    {
      text: '4.500 € - 5.999 €',
      value: 8,
    },
    {
      text: '6.000 € or more',
      value: 9,
    },
  ];

  const foundIncome = incomeMap.find(e => e.value == code);
  return foundIncome?.text;
};

export const getIncomeByCode_UK = code => {
  const incomeMap = [
    {
      text: 'Less than £500',
      value: 1,
    },
    {
      text: '£500 - £899',
      value: 2,
    },
    {
      text: '£900 - £1.499',
      value: 3,
    },
    {
      text: '£1.500 - £1.999',
      value: 4,
    },
    {
      text: '£2.000 - £2.599',
      value: 5,
    },
    {
      text: '£2.600 - £3.199',
      value: 6,
    },
    {
      text: '£3.200 - £4.499',
      value: 7,
    },
    {
      text: '£4.500 - £5.999',
      value: 8,
    },
    {
      text: '£6.000 or more',
      value: 9,
    },
  ];

  const foundIncome = incomeMap.find(e => e.value == code);
  return foundIncome?.text;
};

export const getIncomeCodeByText = text => {
  const value = dataCodeFields.Income.find(income => income.text == text);
  return value?.value;
};

export const getRegionByGlobalRegion = region => {
  const foundRegion = Global_Region.find(e => e.value == region);
  return foundRegion?.text || null;
};

export const getCountryByCode = code => {
  let value = dataCodeFields.Country.find(country => country.value == code);
  return value?.text;
};

export const getEthnicityByCode = code => {
  let value = dataCodeFields.Ethnicity.find(ethnicity => ethnicity.value == code);
  return value?.text;
};

export const getEthnicityCodeByText = text => {
  const value = dataCodeFields.Ethnicity.find(ethnicity => ethnicity.text == text);
  return value?.value;
};

export const getGenderByCode = code => {
  let value = dataCodeFields.Gender.find(gender => gender.value == code);
  return value?.text;
};

export const getEducationByCode = code => {
  let value = dataCodeFields.Education.find(education => education.value == code);
  return value?.text;
};

export const getMaritalStatusByCode = code => {
  let value = dataCodeFields.Marital_status.find(status => status.value == code);
  return value?.text;
};

export const findLatestExistingBatchData = existingBatches => {
  const years = Object.keys(existingBatches)
    .map(Number)
    .sort((a, b) => b - a);
  if (years.length === 0) return null;

  const latestYear = years[0];
  const quarters = existingBatches[latestYear].sort(batchDataSort);
  const latestQuarter = quarters[quarters.length - 1];

  return {
    latestQuarter,
    latestYear,
  };
};

export const getCountryLabel = country => {
  return COUNTRY_LABELS[country] || 'unknown';
};

// Example inputs
// existingBatchData = {'USA': { '2021': ['Q1'], '2022': ['Q2'], '2023': ['Q3'] }};
// customBatchData = {'USA': { '2023': ['Q1_custom', 'Q3_custom'], '2024': ['Q2_custom'] }};
// Output
/*
{
  "USA": {
    "2021": ["Q1"],
    "2022": ["Q2"],
    "2023": [
      "Q1_custom",
      "Q3",
      "Q3_custom"
    ],
    "2024": ["Q2_custom"]
  }
}
*/
export const combineCustomAndRegularBatchDataCodes = (existingBatchData, customBatchData) => {
  let combinedBatchData = {};
  Object.keys(existingBatchData).forEach(e => {
    combinedBatchData[e] = { ...existingBatchData[e] };
  });

  for (const [country, customYears] of Object.entries(customBatchData)) {
    if (!combinedBatchData[country]) {
      combinedBatchData[country] = { ...customYears };
    } else {
      for (const [year, customQuarters] of Object.entries(customYears)) {
        if (combinedBatchData[country][year]) {
          combinedBatchData[country][year] = Array.from(new Set([...combinedBatchData[country][year], ...customQuarters]));
        } else {
          combinedBatchData[country][year] = customQuarters;
        }
      }
    }
  }

  for (const country of Object.keys(combinedBatchData)) {
    for (const year of Object.keys(combinedBatchData[country])) {
      combinedBatchData[country][year].sort(batchDataSort);
    }
  }

  return combinedBatchData;
};

// This function sorts batch data Q with an advantagee to Q instead of Q_custom
// If you have ["Q3", "Q3_custom", "Q1"], the output will be ["Q1", "Q3_custom", "Q3"]
export const batchDataSort = (a, b) => {
  const quarterA = a.replace('_custom', '');
  const quarterB = b.replace('_custom', '');

  const quarterComparison = quarterA.localeCompare(quarterB);

  if (quarterComparison === 0) {
    const isACustom = a.includes('_custom') ? -1 : 1;
    const isBCustom = b.includes('_custom') ? -1 : 1;
    return isACustom - isBCustom;
  }

  return quarterComparison;
};

export const truncateLegendText = (text, screenWidth) => {
  const titleTextLengthConfig = {
    wide: {
      width: 1250,
      textLength: 40,
    },
    medium: {
      width: 878,
      textLength: 25,
    },
    small: {
      width: 450,
      textLength: 25,
    },
    extraSmall: {
      width: 100,
      textLength: 15,
    },
  };

  let screenType =
    screenWidth >= titleTextLengthConfig.wide.width
      ? 'wide'
      : screenWidth >= titleTextLengthConfig.medium.width
      ? 'medium'
      : screenWidth >= titleTextLengthConfig.small.width
      ? 'small'
      : 'extraSmall';

  const wantedTextLength = titleTextLengthConfig[screenType].textLength;
  return text?.length > wantedTextLength ? text.substring(0, wantedTextLength).concat('...') : text;
};
